<template>
  <Form :action="action" :method="method" :form-data="form" @success="success">
    <template v-slot="{ errors, submitting }">
      <label v-if="isNew" class="sm:flex block w-full mb-2">
        <span class="block w-32 py-2 flex-shrink-0">Is een...</span>
        <div class="w-full flex py-2">
          <BaseRadio
            name="type"
            v-model="form.type"
            value="organization"
            label="Organisatie"
            class="mx-2"
          />
          <BaseRadio
            name="type"
            v-model="form.type"
            value="person"
            label="Particulier"
            class="mx-2"
          />
        </div>
      </label>
      <label
        v-for="(field, index) in fields"
        :key="field.identifier"
        class="sm:flex block w-full mb-2"
      >
        <span class="block w-32 py-2 flex-shrink-0">{{ field.name }}</span>
        <div class="w-full">
          <div v-if="field.identifier == 'fullname'" class="flex">
            <BaseInput
              name="firstname"
              id="firstname"
              v-model="form.firstname"
              :error="errors.firstname"
              placeholder="Voornaam"
              class="w-1/2 mr-2"
              required
              v-focus
            />
            <BaseInput
              name="lastname"
              v-model="form.lastname"
              :error="errors.lastname"
              placeholder="Achternaam"
              class="w-1/2"
              required
            />
          </div>
          <BaseInput
            v-else
            :name="field.identifier"
            v-model="form[field.identifier]"
            :error="errors[field.identifier]"
            :required="field.required"
            :type="field.type"
            v-focus="index === 0"
            :class="field.class"
          />
        </div>
      </label>
      <div class="sm:flex w-full my-8">
        <label class="block w-32 py-2 flex-shrink-0" for="street">Adres</label>
        <div class="w-full">
          <BaseInput name="street" id="street" v-model="form.address.street" />
          <div class="flex mt-2 -mx-1">
            <BaseInput name="postal_code" v-model="form.address.postal_code" class="w-40 mx-1" />
            <BaseInput name="city" v-model="form.address.city" class="flex-1 mx-1" />
          </div>
        </div>
      </div>
      <label
        v-for="customfield in customfields"
        :key="customfield.identifier"
        class="sm:flex block w-full mb-2"
      >
        <span class="block w-32 py-2 flex-shrink-0 truncate pr-2">{{ customfield.name }}</span>
        <BaseSelect
          v-if="customfield.type == 'select'"
          :name="customfield.identifier"
          v-model="form.customfields[customfield.id]"
          :options="customfield.options"
          class="w-full"
          optional
        />
        <BaseInput
          v-else
          :name="customfield.identifier"
          v-model="form.customfields[customfield.id]"
          class="w-full"
        />
      </label>
      <div class="sm:ml-32 mt-8">
        <button type="submit" class="btn btn-blue" :disabled="submitting">Opslaan</button>
        <button type="button" class="cancel" @click="$emit('cancel')">Annuleren</button>
      </div>
    </template>
  </Form>
</template>

<script>
import { mapObjectsById } from "@/functions.js";
import Form from "@/components/Form";

export default {
  props: {
    action: {
      type: String,
      required: true
    },
    method: {
      type: String,
      default: "post"
    },
    isNew: {
      type: Boolean
    },
    contact: {
      type: Object
    }
  },

  components: {
    Form
  },

  data() {
    return {
      form: {
        type: "organization",
        customfields: {},
        address: {
          street: "",
          postal_code: "",
          city: ""
        }
      }
    };
  },

  watch: {
    contact() {
      this.fillForm();
    },

    "form.type": {
      handler() {
        this.$emit("change-type", this.form.type);
      }
    }
  },

  created() {
    if (this.contact && this.contact.contact_type == "person") {
      this.form.type = "person";
    }

    this.fillForm();
  },

  computed: {
    fields() {
      let getter =
        this.form.type == "organization"
          ? this.$store.getters.organizationFields
          : this.$store.getters.personFields;

      return getter.map(field => {
        return {
          ...field,
          required: field.identifier == "name",
          type: field.identifier == "email" ? "email" : "text",
          class: field.identifier == "telephone" ? "w-40" : ""
        };
      });
    },

    customfields() {
      return this.$store.state.settings.customfields;
    }
  },

  methods: {
    success(contact) {
      this.$emit("success", contact);
    },

    fillForm() {
      let contact = this.contact || {};

      if (contact.contact) {
        for (let field of this.$store.state.settings.fields) {
          this.$set(
            this.form,
            field.identifier,
            contact.contact[field.identifier]
          );
        }

        // Change fullname to firstname + lastname
        this.form.firstname = contact.contact.firstname;
        this.form.lastname = contact.contact.lastname;
      }

      let map = mapObjectsById(contact.customfields);

      for (let customfield of this.customfields) {
        this.$set(
          this.form.customfields,
          customfield.id,
          map[customfield.id] ? map[customfield.id].value : null
        );
      }

      if (contact.address) {
        this.form.address = { ...contact.address };
      }
    }
  }
};
</script>
